import { useLocation } from 'react-router-dom';

const CANONICAL_PREFIX = '/master-data';

/**
 * Cross-module embedding helper. Returns the route prefix the user is currently
 * browsing under, so a shared page component (e.g., OrganizationDetailPage) can build
 * internal links that stay inside the embedding module instead of bouncing back
 * to the canonical Master Data URL.
 *
 * Example: a user lands on /sales/companies/abc → `prefix` is "/sales", and
 * intra-master-data links (back to list, related contact, etc.) should be
 * rendered as `/sales/...`. External links (e.g., to a deal or ticket) stay
 * unchanged — those belong to other modules.
 *
 * `isEmbedded` is true when the user is on a mirror route (not /master-data/*).
 */
export interface EmbeddingPrefix {
  prefix: string;
  isEmbedded: boolean;
  canonicalPrefix: string;
}

export function useEmbeddingPrefix(): EmbeddingPrefix {
  const { pathname } = useLocation();
  const match = pathname.match(/^(\/[^/]+)/);
  const prefix = match ? match[1] : CANONICAL_PREFIX;
  return {
    prefix,
    isEmbedded: prefix !== CANONICAL_PREFIX,
    canonicalPrefix: CANONICAL_PREFIX,
  };
}
